<template>
  <div>
    <!-- Forms controls -->
    <b-row
      class="d-flex justify-content-between align-items-center bg-light py-3"
    >
      <b-col md="3">
        <b-form-checkbox switch size="sm" v-model="proposal.steps.forms.actived"
          >Formulários</b-form-checkbox
        >
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.forms.situation"
          :options="formsSituationOptions"
          v-if="proposal.steps.forms.actived"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.forms.status"
          v-if="formsStatusOptions[proposal.steps.forms.situation]"
          :options="formsStatusOptions[proposal.steps.forms.situation]"
          @change="formStatusChange"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          today-button
          reset-button
          close-button
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-model="proposal.steps.forms.dueDate"
          v-if="proposal.steps.forms.situation"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { mask } from "vue-the-mask";
import { CurrencyInput } from "vue-currency-input";

var moment = require("moment");
moment.locale("pt-br");

var bootbox = require("bootbox");

export default {
  name: "ControlOfTheFormsFlow",
  data() {
    return {
      array: "",
      /*showPendingFgtsDialog: false,*/
      formsSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Emitidos",
          text: "Emitidos",
          color: "secondary",
          msg: "Formulários preparados para envio ao cliente em",
          progress: 1,
        },
        {
          value: "Enviados",
          text: "Enviados",
          color: "warning",
          msg: "Formulários enviados ao cliente em",
          progress: 2,
        },
        {
          value: "Recebidos",
          text: "Recebidos",
          color: "",
          msg: "Formulários recebidos à conferir em",
          progress: 0,
        },
      ],
      formsStatusOptions: {
        Recebidos: [
          {
            value: "",
            text: "Selecione o status",
            color: "light",
            msg: "",
            progress: 0,
          },
          {
            value: "Inconforme",
            text: "Inconforme",
            color: "danger",
            msg: "Formulários recebidos e com exigência(s) em",
            progress: 2,
          },
          {
            value: "À carimbar",
            text: "À carimbar",
            color: "primary",
            msg: "Formulários recebidos à carimbar em",
            progress: 5,
          },
          {
            value: "Carimbados",
            text: "Carimbados",
            color: "success",
            msg: "Formulários recebidos e carimbados em",
            progress: 6,
          },
        ],
      },
      selectedProposal: this.$store.state.proposal,
    };
  },
  methods: {
    ...mapMutations(["setModificationNotification"]),
    ...mapActions(["getProposal"]),
    formStatusChange(val) {
      if (
        this.proposal.steps.forms.situation == "Recebidos" &&
        val === "À carimbar" &&
        this.selectedProposal.steps.forms.status !== val
      ) {
        this.setModificationNotification({
          type: "modified",
          created_by: this.user.uid,
          proposalName: this.proposal.name,
          id: this.proposal.id,
          text:
            "Formulários recebidos conforme. Carimbe os formulários para inclusão no SICTD.",
        });
      }
    },
  },
  computed: {
    ...mapState(["proposal", "user", "proposalToCheck"]),
  },
  directives: {
    mask,
  },
  components: {
    CurrencyInput,
  },
  watch: {
    "proposal.steps.forms.situation"(newVal, oldVal) {
      if (oldVal || !this.proposal.steps.forms.dueDate) {
        var today = new Date();
        var formstDate = moment(today).format("YYYY-MM-DD");
        this.proposal.steps.forms.dueDate = formstDate;
      }
      if (newVal) {
        for (let key in this.formsSituationOptions) {
          if (newVal === this.formsSituationOptions[key].value) {
            this.proposal.steps.forms.color = this.formsSituationOptions[
              key
            ].color;
            this.proposal.steps.forms.note = this.formsSituationOptions[
              key
            ].msg;
            this.proposal.steps.forms["progress"] = this.formsSituationOptions[
              key
            ].progress;
          }
        }
      } else {
        this.proposal.steps.forms.color = "light";
        this.proposal.steps.forms.note = "";
        this.proposal.steps.forms.progress = 0;
      }
    },
    "proposal.steps.forms.status"(newVal, oldVal) {
      if (newVal) {
        let situationArr = this.formsStatusOptions[
          this.proposal.steps.forms.situation
        ];
        situationArr.forEach((situation) => {
          if (situation.value === newVal) {
            if (situation.color)
              this.proposal.steps.forms.color = situation.color;
            if (situation.msg) this.proposal.steps.forms.note = situation.msg;
            if (situation.progress)
              this.proposal.steps.forms.progress = situation.progress;
          }
        });
      } else {
        for (let key in this.formsSituationOptions) {
          if (
            this.proposal.steps.forms.situation ===
            this.formsSituationOptions[key].value
          ) {
            this.proposal.steps.forms.color = this.formsSituationOptions[
              key
            ].color;
            this.proposal.steps.forms.note = this.formsSituationOptions[
              key
            ].msg;
            this.proposal.steps.forms.progress = this.formsSituationOptions[
              key
            ].progress;
          }
        }
      }
      // var today = new Date();
      // var formstDate = moment(today).format("YYYY-MM-DD");
      // this.proposal.steps.forms.dueDate = formstDate;
    },
    "proposal.steps.forms.actived"(newVal) {
      if (newVal === false) {
        this.proposal.steps.forms["badgeColor"] = "light";
        this.proposal.steps.forms["color"] = "light";
        this.proposal.steps.forms["dueDate"] = "";
        this.proposal.steps.forms["note"] = "";
        this.proposal.steps.forms["situation"] = "";
        this.proposal.steps.forms["status"] = "";
        this.proposal.steps.forms["progress"] = 0;
      }
    },
  },
};
</script>
